import {
  Framer as AddressIcon,
  Anchor as AnchorIcon,
  Clock as CapacityAndTimeslotIcon,
  List as CategoryIcon,
  CheckCircle,
  CheckSquare,
  DollarSign as DollarSignIcon,
  FilePlus as FilePlusIcon,
  Archive as ItemIcon,
  MessageCircle as MessageCircleIcon,
  MessageSquare as MessageSquareIcon,
  Bell as NotificationIcon,
  PieChart as PieChartIcon,
  PlusCircle,
  Award as PromotionIcon,
  RotateCcw as RotateCcwIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  Database as StockIcon,
  Codesandbox as SupplierIcon,
  Send as TicketIcon,
  Truck as TruckIcon,
  User as UserIcon
} from "react-feather";
import {useIntl} from "react-intl";
import {useSelector} from "react-redux";

import _ from "lodash";

import {Dashboard} from "@material-ui/icons";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AssignmentIcon from "@material-ui/icons/Assignment";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
import FilterTiltShiftIcon from "@material-ui/icons/FilterTiltShift";
import GTranslateIcon from "@material-ui/icons/GTranslate";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import PagesIcon from "@material-ui/icons/Pages";
import PermMediaIcon from "@material-ui/icons/PermMedia";
import RateReviewIcon from "@material-ui/icons/RateReview";
import SecurityIcon from "@material-ui/icons/Security";
import StorefrontIcon from "@material-ui/icons/Storefront";
import SupervisorAccountOutlinedIcon from "@material-ui/icons/SupervisorAccountOutlined";

// import useFlatform from "src/hooks/useFlatform";

const ID_METADATA = "ui_master_data";

function NavConfig() {
  const {user} = useSelector((state) => state.account);
  const {formatMessage} = useIntl();
  // const {flatform} = useFlatform();
  // const isCashier = flatform.flatformIndex.key === "oms_cashier";

  const navConfig = [
    {
      subheader: " ",
      idSubheader: "ui_reports",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-homepage",
            defaultMessage: "Home Page",
            description: ""
          }),
          idDropdown: "dashboard_dropdown",
          icon: Dashboard,
          href: "/app/reports/dashboard_new"
        }
      ]
    },
    {
      subheader: formatMessage({
        id: "navbar-content",
        defaultMessage: "Content",
        description: ""
      }),
      idSubheader: "ui_content",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        // {
        //   title: 'Product',
        //   idDropdown: 'product_dropdown',
        //   icon: ItemIcon,
        //   items: [
        //     {
        //       title: 'List Product',
        //       idDropdown: 'item_dropdown',
        //       icon: ItemIcon,
        //       href: '/app/content/product-management'
        //     },
        //     {
        //       title: 'Create Product',
        //       idDropdown: 'item_dropdown',
        //       icon: ItemIcon,
        //       href: '/app/content/product-management/create'
        //     }
        //   ]
        // },
        // {
        //   title: 'Product',
        //   idDropdown: 'item_dropdown',
        //   icon: ItemIcon,
        //   href: '/app/content/item-management'
        // },
        {
          title: formatMessage({
            id: "navbar-content-product",
            defaultMessage: "Product",
            description: ""
          }),
          idDropdown: "item_dropdown",
          icon: ItemIcon,
          href: "/app/content/product-management"
        },
        // {
        //   title: 'Primary Attribute',
        //   idDropdown: 'primary_attribute_dropdown',
        //   icon: ProductAttributeIcon,
        //   href: '/app/content/variants'
        // },
        // {
        //   title: 'Extra Attribute',
        //   idDropdown: 'extra_attribute_dropdown',
        //   icon: ProductAttributeIcon,
        //   href: '/app/content/item-attributes'
        // },
        {
          title: formatMessage({
            id: "navbar-content-category",
            defaultMessage: "Category",
            description: ""
          }),
          idDropdown: "category_dropdown",
          icon: CategoryIcon,
          href: "/app/content/category-management"
        },
        // {
        //   title: formatMessage({
        //     id: "navbar-content-media",
        //     defaultMessage: "Media",
        //     description: ""
        //   }),
        //   idDropdown: "media_dropdown",
        //   icon: PermMediaIcon,
        //   href: "/app/content/media"
        // },
        {
          title: formatMessage({
            id: "navbar-content-brand",
            defaultMessage: "Brand",
            description: ""
          }),
          idDropdown: "brand_dropdown",
          icon: ListAltIcon,
          href: "/app/content/brand"
        },
        // {
        //   title: formatMessage({
        //     id: "navbar-content-seller",
        //     defaultMessage: "Seller",
        //     description: ""
        //   }),
        //   idDropdown: "seller_dropdown",
        //   icon: StorefrontIcon,
        //   href: "/app/content/seller"
        // }
      ]
    },
    {
      subheader: formatMessage({
        id: "navbar-sourcing",
        defaultMessage: "Sourcing",
        description: ""
      }),
      idSubheader: "ui_sourcing",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-sourcing-supplier",
            defaultMessage: "Supplier",
            description: ""
          }),
          idDropdown: "supplier_dropdown",
          icon: SupplierIcon,
          href: "/app/management/supplier"
        },
        {
          title: formatMessage({
            id: "navbar-sourcing-stock",
            defaultMessage: "Stock",
            description: ""
          }),
          idDropdown: "stock_dropdown",
          icon: StockIcon,
          href: "/app/management/stocks"
        },
        // {
        //   title: 'Stock Fulfillment',
        //   idDropdown: 'stock_dropdown',
        //   icon: StockIcon,
        //   href: '/app/management/stocks-fulfillment'
        // },
        // {
        //   title: formatMessage({
        //     id: "navbar-sourcing-reportStock",
        //     defaultMessage: "Report Stocks",
        //     description: ""
        //   }),
        //   idDropdown: "report_stock_dropdown",
        //   icon: StockIcon,
        //   href: "/app/management/report-stocks"
        // },
        {
          title: formatMessage({
            id: "navbar-sourcing-station",
            defaultMessage: "Station",
            description: ""
          }),
          idDropdown: "station_dropdown",
          icon: AnchorIcon,
          href: "/app/management/station"
        }
      ]
    },
    {
      subheader: formatMessage({
        id: "navbar-commercial",
        defaultMessage: "Commercial",
        description: ""
      }),
      idSubheader: "ui_commercial",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-commercial-promotion",
            defaultMessage: "Promotion",
            description: ""
          }),
          idDropdown: "promotion_dropdown",
          icon: PromotionIcon,
          href: "/app/management/promotion"
        },

        {
          title: formatMessage({
            id: "navbar-commercial-privateCoupon",
            defaultMessage: "Private Coupon",
            description: ""
          }),
          idDropdown: "private_coupon_dropdown",
          icon: CardGiftcardIcon,
          href: "/app/management/private-coupon"
        },
        {
          title: formatMessage({
            id: "navbar-commercial-settingCoupon",
            defaultMessage: "Setting Coupon",
            description: ""
          }),
          idDropdown: "coupon_dropdown",
          icon: AccountBalanceIcon,
          href: "/app/management/setting-coupon"
        },
        {
          title: formatMessage({
            id: "navbar-commercial-customerFee",
            defaultMessage: "Customer Fee",
            description: ""
          }),
          idDropdown: "customer_fee_dropdown",
          icon: DollarSignIcon,
          href: "/app/management/customer-fee"
        },
        {
          title: formatMessage({
            id: "navbar-commercial-capacity2TimeSlot",
            defaultMessage: "Capacity & Time-slot",
            description: ""
          }),
          idDropdown: "capacity_and_time_slot_dropdown",
          icon: CapacityAndTimeslotIcon,
          href: "/app/management/time-slot-capacity"
        },
        {
          title: formatMessage({
            id: "navbar-commercial-shippingType",
            defaultMessage: "Shipping Type",
            description: ""
          }),
          idDropdown: "ui_shipping_type",
          icon: TruckIcon,
          href: "/app/management/shipping-type"
        }
      ]
    },
    {
      subheader: formatMessage({
        id: "navbar-customerService",
        defaultMessage: "Customer Service",
        description: ""
      }),
      idSubheader: "ui_customer_service",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-customerService-customer",
            defaultMessage: "Customer",
            description: ""
          }),
          idDropdown: "customer_dropdown",
          icon: UserIcon,
          href: "/app/management/customers"
        },
        {
          title: formatMessage({
            id: "navbar-customerService-notification",
            defaultMessage: "Notification",
            description: ""
          }),
          idDropdown: "notification_dropdown",
          icon: NotificationIcon,
          href: "/app/management/notification/rules"
        },
        // {
        //   title: formatMessage({
        //     id: "navbar-customerService-orderVerification",
        //     defaultMessage: "Order Verification",
        //     description: ""
        //   }),
        //   idDropdown: "order_verification_dropdown",
        //   icon: CheckCircle,
        //   href: "/app/management/order-verification"
        // },
        {
          title: formatMessage({
            id: "navbar-customerService-comment",
            defaultMessage: "Comment",
            description: ""
          }),
          idDropdown: "comment_dropdown",
          icon: MessageSquareIcon,
          href: "/app/content/comments"
        },
        {
          title: formatMessage({
            id: "navbar-customerService-review",
            defaultMessage: "Review",
            description: ""
          }),
          idDropdown: "review_dropdown",
          icon: RateReviewIcon,
          href: "/app/content/review"
        },
        {
          title: formatMessage({
            id: "navbar-customerService-ticket",
            defaultMessage: "Ticket",
            description: ""
          }),
          idDropdown: "ticket_dropdown",
          icon: TicketIcon,
          href: "/app/management/ticket"
        },
        {
          title: formatMessage({
            id: "navbar-customerService-refundTransaction",
            defaultMessage: "Refund Transaction",
            description: ""
          }),
          idDropdown: "refund_transaction_dropdown",
          icon: DollarSignIcon,
          href: "/app/management/refund-transaction"
        },
        {
          title: formatMessage({
            id: "navbar-customerService-returnPackage",
            defaultMessage: "Return Package",
            description: ""
          }),
          idDropdown: "return_package_dropdown",
          icon: DollarSignIcon,
          href: "/app/management/return-package"
        }
      ]
    },
    {
      subheader: formatMessage({
        id: "navbar-orderManagement",
        defaultMessage: "Order Management",
        description: ""
      }),
      idSubheader: "ui_order_management",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-orderManagement-createOrder",
            defaultMessage: "Create Order",
            description: ""
          }),
          idDropdown: "order_dropdown",
          icon: PlusCircle,
          href: "/app/management/order/create"
        },
        {
          title: formatMessage({
            id: "navbar-orderManagement-order",
            defaultMessage: "Order",
            description: ""
          }),
          idDropdown: "order_dropdown",
          icon: ShoppingBagIcon,
          href: "/app/management/order"
        },
        {
          title: formatMessage({
            id: "navbar-orderManagement-pickList",
            defaultMessage: "Picklist",
            description: ""
          }),
          idDropdown: "picklist_dropdown",
          icon: AssignmentIcon,
          href: "/app/management/picklist"
        },
        {
          title: formatMessage({
            id: "navbar-orderManagement-holdPickList",
            defaultMessage: "Hold Picklist",
            description: ""
          }),
          idDropdown: "hold_picklist_dropdown",
          icon: ShoppingBagIcon,
          href: "/app/management/hold-picklist"
        },
        {
          title: formatMessage({
            id: "navbar-orderManagement-returnInvoice",
            defaultMessage: "Approve Return Invoice",
            description: ""
          }),
          idDropdown: "return_invoices_dropdown",
          icon: RotateCcwIcon,
          href: "/app/management/approve-return-invoice"
        }
        // {
        //   title: 'Order Process',
        //   idDropdown: 'order_process_dropdown',
        //   icon: ShoppingBagIcon,
        //   href: '/app/management/order-process'
        // }
        // {
        //   title: 'Package',
        //   idDropdown: 'package_dropdown',
        //   icon: ShoppingBagIcon,
        //   href: '/app/management/package'
        // }
      ]
    },
    // {
    //   subheader: formatMessage({
    //     id: "navbar-cashierManagement",
    //     defaultMessage: "Cashier Management",
    //     description: ""
    //   }),
    //   idSubheader: "ui_cashier_management",
    //   iconHeader: PieChartIcon,
    //   hideInMenu: true,
    //   items: [
    //     {
    //       title: formatMessage({
    //         id: "navbar-orderManagement-order-cashier",
    //         defaultMessage: "Order For Cashier",
    //         description: ""
    //       }),
    //       idDropdown: "order_dropdown",
    //       icon: ShoppingBagIcon,
    //       href: "/app/management/order-cashier"
    //     }
    //   ]
    // },
    {
      subheader: formatMessage({
        id: "navbar-reportManagement",
        defaultMessage: "Report",
        description: ""
      }),
      idSubheader: "ui_report_management",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-reportManagement-report",
            defaultMessage: "Operation Dashboard",
            description: ""
          }),
          idDropdown: "report_dropdown",
          icon: PlusCircle,
          href: "/app/management/report"
        },
        {
          title: formatMessage({
            id: "navbar-reportManagement-cod-report",
            defaultMessage: "COD Report",
            description: ""
          }),
          idDropdown: "co_report_dropdown",
          icon: PlusCircle,
          href: "/app/management/codReport"
        }
      ]
    },
    {
      subheader: formatMessage({
        id: "navbar-transportationHub",
        defaultMessage: "Transportation Hub",
        description: ""
      }),
      idSubheader: "ui_transportation_hub",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        // {
        //   title: formatMessage({
        //     id: "navbar-transportationHub-requestList",
        //     defaultMessage: "Request List",
        //     description: ""
        //   }),
        //   idDropdown: "waybill_dropdown",
        //   icon: ShoppingBagIcon,
        //   href: "/app/management/request-list"
        // },
        {
          title: formatMessage({
            id: "navbar-transportationHub-waybillList",
            defaultMessage: "Waybill List",
            description: ""
          }),
          idDropdown: "distribute_dropdown",
          icon: AssignmentIcon,
          href: "/app/management/waybill-list"
        },
        {
          title: formatMessage({
            id: "navbar-transportationHub-bookingEngine",
            defaultMessage: "Booking Engine",
            description: ""
          }),
          idDropdown: "booking_dropdown",
          icon: FilePlusIcon,
          href: "/app/management/booking-engine"
        }
      ]
    },
    // {
    //   subheader: formatMessage({
    //     id: "navbar-inHouseServices",
    //     defaultMessage: "InHouse Shipping",
    //     description: ""
    //   }),
    //   idSubheader: "ui_inhouse-shipping",
    //   iconHeader: PieChartIcon,
    //   hideInMenu: true,
    //   items: [
    //     {
    //       title: formatMessage({
    //         id: "navbar-transportationHub-shipperInhouse",
    //         defaultMessage: "In-house Shipper",
    //         description: ""
    //       }),
    //       idDropdown: "shipper_inhouse",
    //       icon: FilterTiltShiftIcon,
    //       href: "/app/management/shipper-inhouse"
    //     }
    //   ]
    // },
    {
      subheader: formatMessage({
        id: "navbar-fulfillmentService",
        defaultMessage: "Fulfillment Service",
        description: ""
      }),
      idSubheader: "ui_fulfillment_service",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-fulfillmentService-bagPacking",
            defaultMessage: "Bag Packing",
            description: ""
          }),
          idDropdown: "bag_packing_dropdown",
          icon: ShoppingBagIcon,
          href: "/app/management/bagging"
        }
        // {
        //   title: 'Packaging',
        //   idDropdown: 'packaging_dropdown',
        //   icon: ShoppingBagIcon,
        //   href: '/app/management/package/search'
        // }
      ]
    },
    {
      subheader: formatMessage({
        id: "navbar-campaign-price",
        defaultMessage: "Campaign management",
        description: ""
      }),
      idSubheader: "ui_campaign_price",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-campaign-price-price",
            defaultMessage: "Campaign Price",
            description: ""
          }),
          idDropdown: "campaign_price_dropdown",
          icon: ShoppingBagIcon,
          href: "/app/management/campaign-price"
        }
        // {
        //   title: 'Packaging',
        //   idDropdown: 'packaging_dropdown',
        //   icon: ShoppingBagIcon,
        //   href: '/app/management/package/search'
        // }
      ]
    },
    {
      subheader: formatMessage({
        id: "navbar-masterData",
        defaultMessage: "Master Data",
        description: ""
      }),
      idSubheader: ID_METADATA,
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-masterData-user",
            defaultMessage: "User",
            description: ""
          }),
          idDropdown: "user_dropdown",
          icon: UserIcon,
          items: [
            {
              title: formatMessage({
                id: "navbar-masterData-user-listUser",
                defaultMessage: "List Users",
                description: ""
              }),
              idDropdown: "list_users_customer_dropdown",
              icon: SupervisorAccountOutlinedIcon,
              href: "/app/management/users-customer"
            }
            // {
            //   title: 'List Roles',
            //   idDropdown: 'list_roles_dropdown',
            //   icon: CheckCircle,
            //   href: '/app/management/roles'
            // },
            // {
            //   title: 'List Permissions',
            //   idDropdown: 'list_permissions_dropdown',
            //   icon: CheckSquare,
            //   href: '/app/management/permissions'
            // }
          ]
        },
        {
          title: formatMessage({
            id: "navbar-masterData-location",
            defaultMessage: "Location",
            description: ""
          }),
          idDropdown: "address_dropdown",
          icon: AddressIcon,
          href: "/app/masterdata/address"
        },
        {
          title: formatMessage({
            id: "navbar-masterData-reason",
            defaultMessage: "Reason",
            description: ""
          }),
          idDropdown: "reason_dropdown",
          icon: MessageCircleIcon,
          href: "/app/management/reasons"
        },
        {
          title: formatMessage({
            id: "navbar-masterData-language",
            defaultMessage: "Language",
            description: ""
          }),
          idDropdown: "localization_dropdown",
          icon: GTranslateIcon,
          items: [
            {
              title: formatMessage({
                id: "navbar-masterData-language-listLanguage",
                defaultMessage: "List Languages",
                description: ""
              }),
              idDropdown: "list_languages_dropdown",
              icon: GTranslateIcon,
              href: "/app/management/languages"
            },
            // {
            //   title: 'Create Language',
            //   idDropdown: 'create_language_dropdown',
            //   icon: GTranslateIcon,
            //   href: '/app/management/languages/create'
            // },
            {
              title: formatMessage({
                id: "navbar-masterData-language-listLanguageSetting",
                defaultMessage: "List Language Settings",
                description: ""
              }),
              idDropdown: "list_language_settings_dropdown",
              icon: SettingsIcon,
              href: "/app/management/language-setting"
            }
            // {
            //   title: 'Create Language Setting',
            //   idDropdown: 'create_language_setting_dropdown',
            //   icon: SettingsIcon,
            //   href: '/app/management/language-setting/create'
            // }
          ]
        },
        {
          title: formatMessage({
            id: "navbar-masterData-massUpload",
            defaultMessage: "Mass Upload",
            description: ""
          }),
          idDropdown: "mass_upload_dropdown",
          icon: CloudUploadIcon,
          href: "/app/management/mass-upload"
        },
        {
          title: formatMessage({
            id: "navbar-masterData-policy",
            defaultMessage: "Policy",
            description: ""
          }),
          idDropdown: "policy_dropdown",
          icon: SecurityIcon,
          href: "/app/masterdata/policy"
        },
        // {
        //   title: formatMessage({
        //     id: "navbar-masterData-tag",
        //     defaultMessage: "Tag",
        //     description: ""
        //   }),
        //   idDropdown: "tag_dropdown",
        //   icon: LocalOfferIcon,
        //   href: "/app/masterdata/tag"
        // },
        {
          title: formatMessage({
            id: "navbar-masterData-cms",
            defaultMessage: "CMS",
            description: ""
          }),
          idDropdown: "tag_dropdown",
          icon: PagesIcon,
          href: "/app/masterdata/cms"
        }
        // {
        //   title: 'Metadata',
        //   idDropdown: 'metadata_dropdown',
        //   icon: ExtensionIcon,
        //   href: '/app/management/metadata'
        // }
      ]
    },
    {
      subheader: formatMessage({
        id: "navbar-controlPanel",
        defaultMessage: "Control Panel",
        description: ""
      }),
      idSubheader: "ui_control_panel",
      iconHeader: PieChartIcon,
      hideInMenu: true,
      items: [
        {
          title: formatMessage({
            id: "navbar-controlPanel-platform",
            defaultMessage: "Platform",
            description: ""
          }),
          idDropdown: "platform_dropdown",
          icon: PagesIcon,
          href: "/app/management/platform"
        }
        // {
        //   title: 'Audit log',
        //   idDropdown: 'audit_log_dropdown',
        //   icon: EventNoteIcon,
        //   href: '/app/controlpanel/auditlog'
        // }
      ]
    }
  ];

  const isOwner = _.find(user.roles.data, (role) => role.key === "owner");
  const indexConfig = navConfig.findIndex((item) => item.idSubheader === ID_METADATA);
  if (isOwner && indexConfig > -1) {
    // navConfig[5].items.splice(1, 0, {
    //   title: 'Picklist',
    //   idDropdown: 'picklist_dropdown',
    //   icon: AssignmentIcon,
    //   href: '/app/management/picklist'
    // });

    navConfig[indexConfig].items[0].items.unshift({
      title: formatMessage({
        id: "navbar-masterData-user-listUser2Owner",
        defaultMessage: "List Users - Owner",
        description: ""
      }),
      idDropdown: "super_duper_omega_dropdown",
      icon: UserIcon,
      href: "/app/management/users"
    });
    navConfig[indexConfig].items[0].items.push({
      title: formatMessage({
        id: "navbar-masterData-user-listRole",
        defaultMessage: "List Roles",
        description: ""
      }),
      idDropdown: "list_roles_dropdown",
      icon: CheckCircle,
      href: "/app/management/roles"
    });
    navConfig[indexConfig].items[0].items.push({
      title: formatMessage({
        id: "navbar-masterData-user-listPermission",
        defaultMessage: "List Permissions",
        description: ""
      }),
      idDropdown: "list_permissions_dropdown",
      icon: CheckSquare,
      href: "/app/management/permissions"
    });
    navConfig[indexConfig].items.splice(6, 0, {
      title: formatMessage({
        id: "navbar-masterData-metaData",
        defaultMessage: "Metadata",
        description: ""
      }),
      idDropdown: "metadata_dropdown",
      icon: DynamicFeedIcon,
      href: "/app/masterdata/metadata"
    });
  }

  return navConfig;
}

export default NavConfig;
